
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface ICheckoutDeliveryOptionsDescriptionProps {
    description?: string;
}

/**
 *
 * AddPaymentForm SFC
 * @extends {React.FC<ICheckoutDeliveryOptionsDescriptionProps>}
 */
const CheckoutDeliveryOptionsDescription: React.FC<ICheckoutDeliveryOptionsDescriptionProps> = ({
    description
}) => {
    if (!description) {
        return null;
    }

    return <span className='ms-checkout-delivery-options__description'>{description}</span>;
};

export default CheckoutDeliveryOptionsDescription;